module.exports = __webpack_public_path__ + "static/media/img-wallpaper-manager.01d4daa5.png";